export const VALID_FORMAT = [
  'csv',
  'docx',
  'pdf',
  'doc',
  'xls',
  'xlsm',
  'xlsx',
  'png',
  'jpg',
  'jpeg',
  'msg',
] as const;

export type ValidFileFormat = (typeof VALID_FORMAT)[number];

export function isValidFormat(format: string): format is ValidFileFormat {
  return VALID_FORMAT.includes(format as ValidFileFormat);
}

export const MAXIMUM_SIZE_IN_MB = 100;

export const MAXIMUM_FILE_NUMBER = 20;

export const VALID_SOV_FORMAT = ['csv', 'xlsx'] as const;

export type ValidSOVFormat = (typeof VALID_SOV_FORMAT)[number];

export function isValidSOVFormat(format: string): format is ValidSOVFormat {
  return VALID_SOV_FORMAT.includes(format as ValidSOVFormat);
}
